// ISO 3166-1 alpha-2 → English country name, via `Intl.DisplayNames`.
// Construct the resolver once and reuse — instantiating per call is
// the dominant cost of the lookup. Falls back to the code itself when
// the runtime can't resolve it (very old browsers, or non-country
// codes that slipped through the catalogue).

const COUNTRY_DISPLAY = (() => {
  try { return new Intl.DisplayNames(["en"], { type: "region" }); }
  catch { return null; }
})();

export function countryName(code: string): string {
  if (!code) return "";
  if (!COUNTRY_DISPLAY) return code;
  try {
    return COUNTRY_DISPLAY.of(code) ?? code;
  } catch {
    // `.of()` throws RangeError if `code` isn't a valid region subtag
    // (e.g. a malformed externalRef leaking through the catalogue).
    return code;
  }
}
